import * as React from 'react';
import {GROUP, GROUP_ERROR, GROUP_MAX_SIZE_FILE} from '../../../constants/LabelConstants';
import InputText from '../../../../../common/components/InputText';
import {
    CardCommissionAccountFormDispatchProps, CardCommissionAccountFormStateProps,
} from '../../../types/mx/containers';
import {CardCommissionAccountDataState} from '../../../types/mx/components';
import {isEmpty} from '../../../../../common/utils/ValidationUtils';
import {
    CommissionActFile,
    CommissionCardBackupCodeFile, CommissionCardFileType,
    CommissionIdentificationFile,
    CommissionIdentificationGroupFile,
} from '../../../types/mx/types';
import {COMMON} from '../../../../../common/constants/LabelConstants';
import {FileProps} from '../../../../../common/types/components';
import FileUploader from '../../../../../common/components/FileUploader';
import {DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES} from '../../../../../common/constants/MimeTypeConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';

class CardCommissionAccountView extends React.Component<CardCommissionAccountFormStateProps
    & CardCommissionAccountFormDispatchProps, CardCommissionAccountDataState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
    }

    onPressSave = () => {
        this.setState({showErrors: true}, this.checkData);
    }

    dispatchError = (field: any, cond: (field: any) => boolean,
                     dispatch: (field: any, error: string) => void, error) => {
        if (cond(field)) dispatch(field, error);
    }

    checkData = () => {
        const {
            cardNumber, beneficiaryName, formType,
            onChangeAccountNumber, onChangeBeneficiary, onSave, groupId,
            actFile, identificationFile, identificationGroupFile, cardBackupCodeFile,
            onDropFileAct, onDropFileIdentification, onDropFileIdentificationGroup, onDropFileCardBackupCode
        } = this.props;
        const fieldRequired: string = GROUP_ERROR.GROUP_FIELD_REQUIRED;
        const documentRequired: string = GROUP_ERROR.GROUP_DOCUMENTS_REQUIRED;
        const actFileId = actFile.value;
        const identificationFileId = identificationFile.value;
        const identificationGroupFileId = identificationGroupFile.value;
        const cardBackupCodeFileId = cardBackupCodeFile.value;

        if (this.formHasNotError()) return onSave(groupId, formType);
        this.dispatchError(beneficiaryName.value, isEmpty, onChangeBeneficiary, fieldRequired);
        this.dispatchError(cardNumber.value, isEmpty, onChangeAccountNumber, fieldRequired);
        this.dispatchError(actFileId, (file: CommissionActFile) =>
            (file === null || isEmpty(file.name)), onDropFileAct, documentRequired);
        this.dispatchError(identificationFileId, (file: CommissionIdentificationFile) =>
            (file === null || isEmpty(file.name)), onDropFileIdentification, documentRequired);
        this.dispatchError(identificationGroupFileId, (file: CommissionIdentificationGroupFile) =>
            (file === null || isEmpty(file.name)), onDropFileIdentificationGroup, documentRequired);
        this.dispatchError(cardBackupCodeFileId, (file: CommissionCardBackupCodeFile) =>
            (file === null || isEmpty(file.name)), onDropFileCardBackupCode, documentRequired);
    }

    formHasNotError = () => {
        const {
            cardNumber, beneficiaryName,
            actFile, identificationFile, identificationGroupFile, cardBackupCodeFile
        } = this.props;

        return !!cardNumber.value && !!beneficiaryName.value && cardNumber.error === null &&
            beneficiaryName.error === null && !!actFile.value && !!identificationFile.value
            && !!identificationGroupFile.value && !!cardBackupCodeFile.value ;
    }

    toFile = (file, type) => ({
        url: file.preview,
        mimeType: file.type,
        fileType: type,
        hasError: false,
        content: file,
        isUploaded: false,
        name: file.name,
        size: file.size,
        lastModified: file.lastModified
    })

    onDropFile = (files: FileList, type, section: string, error: string) => {
        const isSizeAllowed: boolean = !!files[0] && files[0].size <= GROUP_MAX_SIZE_FILE;
        const newError: string = isSizeAllowed ? error : COMMON.FILE_SIZE_NOT_ALLOWED;
        const file = isSizeAllowed ? this.toFile(files[0], type) : null;
        switch (type) {
            case CommissionCardFileType.COMMISSION_ACT_TYPE:
                this.props.onDropFileAct(file, newError);
                break;
            case CommissionCardFileType.COMMISSION_IDENTIFICATION_TYPE:
                this.props.onDropFileIdentification(file, newError);
                break;
            case CommissionCardFileType.COMMISSION_IDENTIFICATION_GROUP_TYPE:
                this.props.onDropFileIdentificationGroup(file, newError);
                break;
            case CommissionCardFileType.COMMISSION_CARD_BACKUP_CODE_TYPE:
                this.props.onDropFileCardBackupCode(file, newError);
                break;
        }
    }

    toFileProps = (file, id: string): FileProps => ({
        id, fileName: file.name, mimeType: file.mimeType,
        originalUrl: file.url, compressUrl: file.url, thumbnailUrl: file.url
    })

    onDeleteFile = (id: string, type) => {
        this.props.onDeleteFile(id, type, GROUP_ERROR.GROUP_DOCUMENTS_REQUIRED);
    }

    render() {
        const btnStyle: string = 'btn btn-link btn-form border-0 h-100 pb-2';
        const {
            onCancel, cardNumber, onChangeAccountNumber, beneficiaryName, onChangeBeneficiary,
            actFile, identificationFile, identificationGroupFile, cardBackupCodeFile
        } = this.props;
        const {showErrors} = this.state;

        const actFileValue = !!actFile &&
            actFile.value;
        const actFileList: FileProps[] = actFileValue ?
            [this.toFileProps(actFileValue, 'actFile')] : [];
        const identificationFileValue = !!identificationFile &&
            identificationFile.value;
        const identificationFileList: FileProps[] = identificationFileValue ?
            [this.toFileProps(identificationFileValue, 'identificationFile')] : [];
        const identificationGroupFileValue = !!identificationGroupFile &&
            identificationGroupFile.value;
        const identificationGroupFileList: FileProps[] = identificationGroupFileValue ?
            [this.toFileProps(identificationGroupFileValue, 'identificationGroupFile')] : [];
        const cardBackupCodeFileValue = !!cardBackupCodeFile &&
            cardBackupCodeFile.value;
        const cardBackupCodeFileList: FileProps[] = cardBackupCodeFileValue ?
            [this.toFileProps(cardBackupCodeFileValue, 'cardBackupCodeFile')] : [];

        const formHasNotError: boolean = this.formHasNotError();
        return (
            <div className="col-12 px-0 pt-5 pb-0">
                <div className="row mb-6">
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_CARD_COMMISSION_ACCOUNT_NUMBER_FIELD_TITLE}
                            id="postalCode"
                            required={true}
                            maxLength={15}
                            minLength={12}
                            type={InputTextTypes.ALPHA_NUMERIC}
                            hasError={showErrors}
                            labelError={cardNumber.error}
                            value={cardNumber.value}
                            onChange={onChangeAccountNumber}/>
                    </div>
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_BENEFICIARY_NAME_TITLE}
                            id="postalCode"
                            required={true}
                            minLength={3}
                            hasError={showErrors}
                            labelError={beneficiaryName.error}
                            value={beneficiaryName.value}
                            onChange={onChangeBeneficiary}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col d-flex">
                        <FileUploader
                            id="actFile"
                            type={CommissionCardFileType.COMMISSION_ACT_TYPE}
                            section={null}
                            customClass="mr-2"
                            required={true}
                            multiple={false}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            label={GROUP.GROUP_CREATE_CARD_COMMISSION_ACT_FILE_TITLE}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, CommissionCardFileType.COMMISSION_ACT_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={actFileList}
                            hasError={this.state.showErrors}
                            labelError={' '}/>

                        <FileUploader
                            id="identificationFile"
                            type={CommissionCardFileType.COMMISSION_IDENTIFICATION_TYPE}
                            section={null}
                            customClass="mr-2"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={GROUP.GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_FILE_TITLE}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, CommissionCardFileType.COMMISSION_IDENTIFICATION_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={identificationFileList}
                            hasError={this.state.showErrors}
                            labelError={' '}/>

                        <FileUploader
                            id="identificationGroupFile"
                            type={CommissionCardFileType.COMMISSION_IDENTIFICATION_GROUP_TYPE}
                            section={null}
                            customClass="mr-2"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={GROUP.GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_GROUP_FILE_TITLE}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, CommissionCardFileType.COMMISSION_IDENTIFICATION_GROUP_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={identificationGroupFileList}
                            hasError={this.state.showErrors}
                            labelError={' '}/>

                        <FileUploader
                            id="cardBackupCodeFile"
                            type={CommissionCardFileType.COMMISSION_CARD_BACKUP_CODE_TYPE}
                            section={null}
                            customClass="mr-2"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={GROUP.GROUP_CREATE_CARD_COMMISSION_CARD_BACKUP_CODE_FILE_TITLE}
                            onDrop={this.onDropFile}
                            onDelete={(id: string) =>
                                this.onDeleteFile(id, CommissionCardFileType.COMMISSION_CARD_BACKUP_CODE_TYPE)}
                            onClickThumbnail={() => {}}
                            uploadedFiles={cardBackupCodeFileList}
                            hasError={this.state.showErrors}
                            labelError={' '}/>
                    </div>
                </div>
                <div className="row mb-6">
                    {showErrors && (actFile.error || identificationFile.error
                        || identificationGroupFile.error || cardBackupCodeFile.error) &&
                    <div className="col text-left form-text is-invalid">
                        <img className="ic mr-2" alt="warning"
                             src={AssetsManager('/assets/images/common/warning-icon.svg')}/>
                        {actFile.error || identificationFile.error
                        || identificationGroupFile.error || cardBackupCodeFile.error}
                    </div>}
                </div>
                <div className="col-12 pt-3 px-0 border-top">
                    <div className="d-flex justify-content-end">
                        <a className={`${btnStyle} text-secondary-lighten-5`}
                           onClick={() => onCancel()}>{GROUP.GROUP_CANCEL_LABEL}</a>
                        <a id="saveBtn" className={formHasNotError ? `${btnStyle} text-primary pr-0` :
                            `${btnStyle} text-secondary-lighten-5 pr-0`}
                                           onClick={this.onPressSave}>{GROUP.GROUP_SAVE_LABEL}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardCommissionAccountView;
